<template>
  <div>
    <v-row>
      <v-col cols="12">
        <CertificatesTableHeadingAndSearch
          :disabled="disableSearch"
          @filter="filterBy"
        />
      </v-col>

      <v-col cols="12">
        <CertificatesTableFilters @filter="filterBy" :loading="loading" />
      </v-col>



      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp" class="v-col-overflow">
        <v-row class="v-row-overflow">
          <v-col cols="12">
            <v-card flat style="background: white;" class="rounded-lg primary--text mt-3 px-md-2 mouse-cursor">
              <v-row align="center">
                <v-col cols="auto" class="text-start ps-7" style="width: 120px">
                  <div class="d-flex align-center">
                    <v-checkbox
                      :input-value="isAllSelected"
                      @change="updateSelection(dataList, $event)"
                      :disabled="!dataList || !dataList.length"
                      class="mt-0 pt-0 d-inline-flex"
                      hide-details
                    />

                    {{ $t("all") }}
                  </div>
                </v-col>

                <v-col cols="auto" class="text-start" style="width: 250px">
                  {{ $t("user.registration.organization") }}
                </v-col>

                <v-col cols="auto" class="text-start" style="width: 250px">
                  {{ $t("user.registration.training") }}
                </v-col>

                <v-col cols="auto" class="text-start" style="width: 250px">
                  {{ $t("reports.employee") }}
                </v-col>

                <v-col cols="auto" class="text-start" style="width: 180px">
                  {{ $t("user.certificatesAndProfileCard.completionDate") }}
                </v-col>

                <v-col cols="auto" class="text-start" style="width: 150px">
                  {{ $t("user.certificatesAndProfileCard.type") }}
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row class="v-row-overflow" v-if="!loading && dataList.length">
          <v-col cols="12" class="v-col-overflow">
            <v-row class="d-flex flex-column">
              <v-col cols="12" v-for="(data, index) in dataList" :key="index" class="v-col-overflow flex py-1">
                <CertificatesTableRow
                  :data="data"
                  :isSelected="haveSelected(data)"
                  @onChange="value => updateSelection([data], value)"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row
          v-else-if="!loading && !dataList.length"
          class="textLight--text font-weight-medium my-16"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>

        <v-row v-else-if="loading && !dataList.length" class="my-16">
          <v-col cols="12">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="dataList && dataList.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>

      <v-col cols="12" v-if="dataList && dataList.length">
        <div class="d-flex justify-end">
          <BulkDownloadButton
            :selections="selections"
            :downloading="downloading"
            @onClear="selections = []"
            @onClick="bulkDownload"
          />
        </div>
      </v-col>
    </v-row>

    <!-- Modern Progress Modal Dialog -->
    <v-dialog
      v-model="downloading"
      persistent
      max-width="440"
      overlay-opacity="0.55"
      overlay-color="#0f172a"
      content-class="rounded-xl"
    >
      <v-card class="rounded-xl pa-6 text-center elevation-12">
        <div class="d-flex justify-center my-2">
          <v-progress-circular
            :rotate="-90"
            :size="90"
            :width="7"
            :value="downloadProgressPercentage"
            color="primary"
          >
            <span class="text-h6 font-weight-bold primary--text">
              {{ Math.round(downloadProgressPercentage) }}%
            </span>
          </v-progress-circular>
        </div>

        <div class="text-h6 font-weight-bold primary--text mt-3 mb-1">
          Downloading Certificates
        </div>

        <div class="text-body-2 textLight--text opacity-70 mb-4">
          Generating PDF files, please wait...
        </div>

        <v-progress-linear
          :value="downloadProgressPercentage"
          color="primary"
          height="8"
          rounded
          striped
          animated
          class="mb-3"
        ></v-progress-linear>

        <div class="d-flex justify-space-between text-caption font-weight-medium textLight--text px-1">
          <span>Processing certificates</span>
          <span class="font-weight-bold primary--text">{{ downloadProgressCurrent }} of {{ downloadProgressTotal }}</span>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CertificatesTableHeadingAndSearch from "./CertificatesTableHeadingAndSearch";
import CertificatesTableFilters from "./CertificatesTableFilters";
import CertificatesTableRow from "@/app/user-module/components/certificate-and-profile-card/CertificatesTableRow";
import BulkDownloadButton from "@/app/core-module/components/BulkDownloadButton";
import Pagination from "../../../core-module/components/Pagination.vue";

import { bulkDownloadTrainingCertificates } from "@/app/user-module/helpers/certificateHelper";

export default {
  name: "CertificatesTable",
  components: {
    CertificatesTableHeadingAndSearch,
    CertificatesTableFilters,
    CertificatesTableRow,
    BulkDownloadButton,
    Pagination
  },
  data() {
    return {
      loading: true,
      variables: {
        limit: 10,
        skip: 0,
      },
      dataList: [],
      totalCount: null,
      search: null,
      disableSearch: false,
      organization: null,
      training: null,
      employee: null,
      datesRange: {
        startDate: null,
        endDate: null,
      },
      selections: [],
      subscriberInfo: null,
      downloading: false,
      totalPages: 0,
      downloadProgressCurrent: 0,
      downloadProgressTotal: 0,
    };
  },
  computed: {
    downloadProgressPercentage() {
      if (this.downloadProgressTotal === 0) return 0;
      return (this.downloadProgressCurrent / this.downloadProgressTotal) * 100;
    },
    isAllSelected() {
      return (
        this.selections?.length &&
        this.dataList?.length &&
        this.dataList?.every(x => this.haveSelected(x))
      );
    },
  },
  apollo: {
    getTrainingCertificates() {
      return {
        query: require("../../../course-module/api/query/getTrainingCertificates.gql"),
        variables: this.variablesDefaultValue(),
        result({ data, loading }) {
          if (data?.getTrainingCertificates?.trainingCertificates) {
            this.dataList = data.getTrainingCertificates.trainingCertificates;
            this.totalCount = data.getTrainingCertificates.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          }

          this.loading = loading;
        },
      };
    },
    getSubscriberProfile() {
      return {
        query: require("../../api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    haveSelected(obj) {
      return this.selections?.findIndex(x => x._id === obj._id) >= 0;
    },
    updateSelection(list, isSelected) {
      list.forEach(obj => {
        const existingIndex = this.selections.findIndex(x => x._id === obj._id);

        if (isSelected) {
          if (existingIndex < 0) {
            this.selections.push(obj);
          }
        } else {
          if (existingIndex >= 0) {
            this.selections.splice(existingIndex, 1);
          }
        }
      });
    },
    bulkDownload() {
      this.downloading = true;
      this.downloadProgressCurrent = 0;
      this.downloadProgressTotal = this.selections.length;

      bulkDownloadTrainingCertificates({
        trainingCertificates: this.selections,
        subscriberInfo: this.subscriberInfo,
        onProgress: (current, total) => {
          this.downloadProgressCurrent = current;
          this.downloadProgressTotal = total;
        }
      }).then(response => {
        if (response) this.selections = [];
        this.downloading = false;
        this.downloadProgressCurrent = 0;
      });
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    filterBy(key, value) {
      if (key === "search") this.search = value;
      if (key === "organization") this.organization = value;
      if (key === "training") this.training = value;
      if (key === "employee") this.employee = value;

      if (key === "dates") {
        this.datesRange.startDate = value.startDate;
        this.datesRange.endDate = value.endDate;
      }

      this.variables.limit = 10;
      this.variables.skip = 0;

      this.refetch();
    },
    async refetch() {
      await this.$apollo.queries.getTrainingCertificates.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: {
          search: this.search ? this.search : null,
          organization: this.organization ? this.organization : null,
          training: this.training ? this.training : null,
          employee: this.employee ? this.employee : null,
          dateFrom: this.datesRange.startDate
            ? this.datesRange.startDate
            : null,
          dateTo: this.datesRange.endDate ? this.datesRange.endDate : null,
        },
      });
    },
  },
};

</script>
